export default {
    name: 'formia-solutions',
    component(resolve) {
        require(['../components/pages/formia/Show.vue'], resolve)
    },
    subRoutes: {
        '/te23_1100': {
            component(resolve) {
                require(['../components/pages/formia/te231100.vue'], resolve)
            }
        },
        '/single-servo-press-tile-line': {
            component(resolve) {
                require(['../components/pages/formia/ssptl.vue'], resolve)
            }
        },
        '/roofing-solutions': {
            component(resolve) {
                require(['../components/pages/formia/roofSols.vue'], resolve)
            }
        },
        '/other-solutions': {
            component(resolve) {
                require(['../components/pages/formia/otherSols.vue'], resolve)
            }
        },
        '/cladding-solutions': {
            component(resolve) {
                require(['../components/pages/formia/claddingSols.vue'], resolve)
            }
        },
        '/framing-solutions': {
            component(resolve) {
                require(['../components/pages/formia/framingSols.vue'], resolve)
            }
        },
        /*,
        '/pbsm/prod01': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod01.vue'], resolve)
            }
        },
        '/pbsm/prod02': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod02.vue'], resolve)
            }
        },
        '/pbsm/prod03': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod03.vue'], resolve)
            }
        },
        '/pbsm/prod04': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod04.vue'], resolve)
            }
        },
        '/pbsm/prod05': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod05.vue'], resolve)
            }
        }*/
    }
}


// WEBPACK FOOTER //
// ./src/routermappings/formia_rm_config.js